exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.wide_button[data-v-48a9046c]{\n  width: 100%;\n  text-transform: none;\n}\n", ""]);

// exports
